import React from "react";
import { Link } from "react-router-dom";
import { FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import {
  Rocket,
  Lightbulb,
  Layers,
  Mail,
  MapPin,
  ArrowRight,
  ShieldCheck
} from "lucide-react";

export default function InnovationHubFooter() {
  return (
    <footer
      className="bg-[#1565C0] px-4 pb-6 pt-10 md:px-6 text-white"
      style={{ fontFamily: "Poppins, sans-serif" }}
    >
      <div className="mx-auto max-w-[1500px]">
        <div className="grid gap-8 lg:grid-cols-[1.25fr_0.8fr_0.8fr]">
          
          {/* BRAND */}
          <div>
            <h2 className="text-xl font-bold md:text-2xl">
              İTK Innovation Hub
            </h2>

            <p className="mt-3 max-w-sm text-sm text-white/80 leading-relaxed">
              Fikirlerin projeye, projelerin girişime dönüştüğü yaratıcı
              ekosistem.
            </p>

            {/* <Link
              to="/starter-application"
              className="mt-5 inline-flex items-center gap-2 rounded-xl bg-white text-[#1565C0] px-4 py-2 text-sm font-semibold transition hover:bg-[#C62828] hover:text-white"
            >
              Başvuru Yap
              <ArrowRight size={16} />
            </Link> */}
          </div>

          {/* LINKS */}
          <FooterColumn title="Hızlı Linkler">
            <FooterLink to="/itk-starter" icon={Rocket}>
              İTK Starter
            </FooterLink>
            <FooterLink to="/research-projects" icon={Layers}>
              Projeler
            </FooterLink>
            <FooterLink to="/events" icon={Lightbulb}>
              Etkinlikler
            </FooterLink>
            <FooterLink to="/kvkk" icon={ShieldCheck}>
              KVKK
            </FooterLink>
          </FooterColumn>

          {/* CONTACT */}
          <FooterColumn title="İletişim">
            <FooterText icon={Mail}>innovationhub@itk.k12.tr</FooterText>
            {/* <FooterText icon={MapPin}>İzmir Özel Türk Koleji</FooterText> */}

            {/* <div className="mt-5 flex gap-3 text-lg">
              <FaInstagram className="cursor-pointer text-white/80 hover:text-pink-400 transition" />
              <FaLinkedin className="cursor-pointer text-white/80 hover:text-blue-300 transition" />
              <FaYoutube className="cursor-pointer text-white/80 hover:text-red-400 transition" />
            </div> */}
          </FooterColumn>
        </div>

        {/* BOTTOM */}
        <div className="mt-8 border-t border-white/20 pt-5 flex flex-col md:flex-row justify-between text-xs text-white/70">
          <p>© 2026 İTK Innovation Hub</p>

          {/* <div className="flex gap-4 mt-2 md:mt-0">
            <Link to="/gizlilik" className="hover:text-white transition">
              Gizlilik
            </Link>
            <Link to="/kvkk" className="hover:text-white transition">
              KVKK
            </Link>
          </div> */}
        </div>
      </div>
    </footer>
  );
}

function FooterColumn({ title, children }) {
  return (
    <div>
      <h3 className="mb-4 text-sm font-semibold text-white">
        {title}
      </h3>
      <div className="space-y-2">{children}</div>
    </div>
  );
}

function FooterLink({ to, icon: Icon, children }) {
  return (
    <Link
      to={to}
      className="flex items-center gap-2 text-sm text-white/80 hover:text-white transition"
    >
      <Icon size={16} className="text-white/80" />
      {children}
    </Link>
  );
}

function FooterText({ icon: Icon, children }) {
  return (
    <div className="flex items-center gap-2 text-sm text-white/80">
      {Icon && <Icon size={16} />}
      <span>{children}</span>
    </div>
  );
}